import { WorkshopEquipmentApi } from './workshopEquipamentDetailsApi';

function formatEquipmentData(equipment) {
  return {
    id: equipment.id,
    nome: equipment.nome || equipment.name,
    marca: equipment.marca || equipment.brand,
    modelo: equipment.modelo || equipment.model,
    ca: equipment.ca || equipment.ca_number,
    serie: equipment.serie || equipment.serial,
    ultima_revisao: equipment.ultima_revisao || equipment.last_revision,
    proxima_revisao: equipment.proxima_revisao || equipment.next_revision,
    status: equipment.status || 'ativo',
    company_id: equipment.company_id
  };
}

function formatPhotoData(photo) {
  return {
    nome_arquivo: photo.nome_arquivo || photo.file_name,
    nome: photo.nome || photo.name
  };
}

function formatReportData(report) {
  return {
    created_at: report.created_at,
    nome_arquivo: report.nome_arquivo || report.file_name,
    nome: report.nome || report.name,
    descricao: report.descricao || report.description
  };
}

function formatEquipmentDetailsData(data) {
  return {
    equipamento: data.equipamento ? formatEquipmentData(data.equipamento) : null,
    fotos: Array.isArray(data.fotos) ? data.fotos.map(formatPhotoData) : [],
    laudos: Array.isArray(data.laudos) ? data.laudos.map(formatReportData) : []
  };
}

function formatarData(dataString) {
  if (!dataString) return '--';
  const data = new Date(dataString);
  return data.toLocaleDateString('pt-BR');
}

function formatarDataHora(dataString) {
  if (!dataString) return '--';
  const data = new Date(dataString);
  return `${data.toLocaleDateString('pt-BR')} - ${data.toLocaleTimeString('pt-BR', {
    hour: '2-digit',
    minute: '2-digit'
  })}`;
}

function isRevisaoPendente(proximaRevisao) {
  if (!proximaRevisao) return false;
  const proximaData = new Date(proximaRevisao);
  const hoje = new Date();
  const diffDias = (proximaData - hoje) / (1000 * 60 * 60 * 24);
  return diffDias <= 60;
}

// Funções principais do serviço
function getEquipmentDetails(id) {
  return WorkshopEquipmentApi.getEquipmentDetails(id)
    .then(response => formatEquipmentDetailsData(response.data));
}

function getEquipmentPhotos(id) {
  return WorkshopEquipmentApi.getEquipmentPhotos(id)
    .then(response => ({
      fotos: Array.isArray(response.data) ? response.data.map(formatPhotoData) : []
    }));
}

function getEquipmentReports(id) {
  return WorkshopEquipmentApi.getEquipmentReports(id)
    .then(response => ({
      laudos: Array.isArray(response.data) ? response.data.map(formatReportData) : []
    }));
}

function downloadReport(fileName) {
  return WorkshopEquipmentApi.downloadReport(fileName)
    .then(response => {
      // Criar URL para download do blob
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      
      return { success: true, message: 'Download iniciado' };
    });
}

export const WorkshopEquipmentService = {
  getEquipmentDetails,
  getEquipmentPhotos,
  getEquipmentReports,
  downloadReport,
  formatEquipmentData,
  formatPhotoData,
  formatReportData,
  formatEquipmentDetailsData,
  formatarData,
  formatarDataHora,
  isRevisaoPendente
};